import React, { Component } from 'react';

//componentes
import CasosAction from './Casos'

class Casos extends Component {

    render(){
        return(
            <div>
                <CasosAction />
            </div>
        );
    }

}
export default Casos;